import React, { useState } from "react"
import { useNavigate } from "react-router-dom"

import { login as loginService } from "../services/auth"
import { useAuthDispatch } from "../contexts/AuthenticationContext/AuthenticationContext.hooks"

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const navigate = useNavigate()
  const { login } = useAuthDispatch()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")

    try {
      const response = await loginService(email, password)

      // If the backend returns JWT tokens, store them in the auth context.
      if (response.access && response.refresh) {
        login({ access: response.access, refresh: response.refresh })
      }

      navigate("/")
    } catch (err: unknown) {
      if (err instanceof Error) {
        console.error("Login error:", err.message)
      }
      setError("Invalid email or password")
    }
  }

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="card" style={{ width: "400px" }}>
        <div className="card-body">
          <h2 className="card-title text-center mb-4">Sign in</h2>
          <form onSubmit={handleSubmit}>
            {error && (
              <div className="alert alert-danger text-center small">
                {error}
              </div>
            )}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="form-control"
                placeholder="Email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="form-control"
                placeholder="Password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button
              type="submit"
              className="btn w-100 text-white"
              style={{ backgroundColor: "#053c2e" }}
            >
              Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
